export const GET_RULES = "GET_RULES";
export const GET_RULE_BY_ID = "GET_RULE_BY_ID";
export const UPDATE_RULE = "UPDATE_RULE";
export const DELETE_RULE = "DELETE_RULE";
export const CREATE_RULE = "CREATE_RULE";
